// Single source of truth for the next/image host allowlist, shared by
// next.config.js (build-time `images.remotePatterns`) and
// src/utils/images/isAllowedImageSrc.ts (runtime guard).
//
// List each domain once, at its apex. Both the apex and every subdomain depth
// are derived below, because next/image's `**.` wildcard matches subdomains at
// any depth but NOT the apex itself — so serving an image straight off
// https://fanatiz.com/… requires its own entry. Root domains matter when
// traffic is redirected to a base domain during a landing-page outage
// (FZSPF-3789).
const DOMAINS = [
  'nunchee.com',
  'nunchee.tv',
  'fanatiz.com',
  'l1max.com',
  'liga1play.com',
  'afaplay.tv',
  'cdoplus.cl',
]

const HOSTS = DOMAINS.flatMap(domain => [domain, `**.${domain}`])

module.exports = [
  // Dev only (next dev runs on 8080). Pinning the port keeps the optimizer
  // from being pointed at arbitrary loopback ports; in production the
  // localhost entry is inert anyway because dangerouslyAllowLocalIP is off.
  { protocol: 'http', hostname: 'localhost', port: '8080', pathname: '/**' },
  ...HOSTS.map(hostname => ({ protocol: 'https', hostname, pathname: '/**' })),
]
